/**
 * Top 144 FDA-approved / most-prescribed medication names (generic) for voice recognition.
 * When the system is listening specifically for a medication name (add or edit), this list
 * is used as the candidate set for ASR correction (with the user's current medications).
 * Source: ClinCalc DrugStats Top 200 (2023), US outpatient prescription volume.
 * Limited to 144 for recognition performance; expand as needed.
 */

export const TOP_FDA_MEDICATION_NAMES = [
  'Atorvastatin',
  'Metformin',
  'Levothyroxine',
  'Lisinopril',
  'Amlodipine',
  'Metoprolol',
  'Albuterol',
  'Losartan',
  'Gabapentin',
  'Omeprazole',
  'Sertraline',
  'Rosuvastatin',
  'Pantoprazole',
  'Escitalopram',
  'Dextroamphetamine',
  'Hydrochlorothiazide',
  'Bupropion',
  'Fluoxetine',
  'Semaglutide',
  'Montelukast',
  'Trazodone',
  'Simvastatin',
  'Amoxicillin',
  'Tamsulosin',
  'Hydrocodone',
  'Fluticasone',
  'Meloxicam',
  'Apixaban',
  'Furosemide',
  'Insulin Glargine',
  'Duloxetine',
  'Ibuprofen',
  'Famotidine',
  'Empagliflozin',
  'Carvedilol',
  'Tramadol',
  'Alprazolam',
  'Prednisone',
  'Hydroxyzine',
  'Buspirone',
  'Clopidogrel',
  'Glipizide',
  'Citalopram',
  'Potassium Chloride',
  'Allopurinol',
  'Aspirin',
  'Cyclobenzaprine',
  'Ergocalciferol',
  'Oxycodone',
  'Methylphenidate',
  'Venlafaxine',
  'Spironolactone',
  'Ondansetron',
  'Zolpidem',
  'Cetirizine',
  'Estradiol',
  'Pravastatin',
  'Lamotrigine',
  'Quetiapine',
  'Clonazepam',
  'Dulaglutide',
  'Azithromycin',
  'Latanoprost',
  'Cholecalciferol',
  'Propranolol',
  'Ezetimibe',
  'Topiramate',
  'Paroxetine',
  'Diclofenac',
  'Atenolol',
  'Lisdexamfetamine',
  'Doxycycline',
  'Pregabalin',
  'Glimepiride',
  'Tizanidine',
  'Clonidine',
  'Fenofibrate',
  'Insulin Lispro',
  'Valsartan',
  'Cephalexin',
  'Baclofen',
  'Rivaroxaban',
  'Ferrous Sulfate',
  'Amitriptyline',
  'Finasteride',
  'Dapagliflozin',
  'Folic Acid',
  'Aripiprazole',
  'Olmesartan',
  'Valacyclovir',
  'Mirtazapine',
  'Lorazepam',
  'Levetiracetam',
  'Insulin Aspart',
  'Naproxen',
  'Cyanocobalamin',
  'Loratadine',
  'Diltiazem',
  'Sumatriptan',
  'Triamcinolone',
  'Hydralazine',
  'Tirzepatide',
  'Celecoxib',
  'Acetaminophen',
  'Alendronate',
  'Oxybutynin',
  'Warfarin',
  'Progesterone',
  'Testosterone',
  'Nifedipine',
  'Methocarbamol',
  'Benzonatate',
  'Sitagliptin',
  'Chlorthalidone',
  'Isosorbide',
  'Donepezil',
  'Dexmethylphenidate',
  'Sulfamethoxazole Trimethoprim',
  'Clobetasol',
  'Methotrexate',
  'Hydroxychloroquine',
  'Lovastatin',
  'Pioglitazone',
  'Irbesartan',
  'Methylprednisolone',
  'Norethindrone',
  'Meclizine',
  'Ketoconazole',
  'Azelastine',
  'Nitrofurantoin',
  'Adalimumab',
  'Memantine',
  'Prednisolone',
  'Esomeprazole',
  'Docusate',
  'Clindamycin',
  'Acyclovir',
  'Sildenafil',
  'Insulin Degludec',
  'Levocetirizine',
  'Budesonide',
  'Tiotropium',
  'Tadalafil',
  'Enalapril',
];
